import { shape, string} from 'prop-types';

export const arrayMultimedia = shape({
	url: string.isRequired,
	mediaType: string.isRequired
})